import Vue2Filters from 'vue2-filters'
import Vue from 'vue'

Vue.use(Vue2Filters)

/**
 * Filter for formatting currencies
 * Defaults to EUR
 */
export const money = function (value, symbol) {
  let currency = Vue.filter('currency')
  symbol = symbol != null ? symbol : '€ '
  return currency(value, symbol, 2, { thousandsSeparator: '.', decimalSeparator: ',' })
}

Vue.filter('money', money)



// WEBPACK FOOTER //
// ./src/utils/filters.js